/**
 * Created by sungho.hong on 2019-03-06.
 */

export default Object.freeze({

    /* Language */
    ENGLISH: 'en',
    KOREAN: 'ko',
    CHINESE: 'zh',
    JAPANESE: 'ja',

    /* Language 코드 (타 서비스와 공통으로 사용함 Value 변경 권장하지 않음) */
    LangCode: 'BSP_LangCode',

    SERVICE: {
        PORTAL: "portal",
        ASSET: "asset",
        GOVERNANCE: "gov"
    },
    VENDOR: {
        AWS : "aws",
        AZURE : "azu",
        GCP : "gcp",
        ALI : "ali",
        OTHER: "Others"
    },
    /* Menu Code */
    MENU: {
        DASHBOARD: 'GOV010',
        COMPLIANCE_ASSESSMENT: 'GOV020',
        POLICY: 'GOV030',
        COMPLIANCE_LOGS: 'GOV040',
        SETTINGS: 'GOV050'
    },
    AUTH_TYPE: {
        EDIT: 'AUTH_TYPE_010',
        VIEW: 'AUTH_TYPE_020',
        NONE: 'AUTH_TYPE_030'
    },
    HTTP_STATUS: {
        OK: 'ok',
        FAIL: 'fail',
        ERROR: 'error'
    },
    ROLE_CODE: {
        ADMIN: "ROLE_ADM",
        SERVICE_MANAGER: "ROLE_SVCMNGR",
        RESPONSER: "ROLE_RSPNR",
        OBSERVER: "ROLE_OBSVR",
        USER: "ROLE_USER",
        NON_USER: "NON_USER"
    },
    /* SSO 관련 */
    ACCESS_TOKEN: 'access_token',         // 운영계 엑세스 토큰
    ACCESS_TOKEN_DEV: 'access_token_dev', // 개발계 엑세스 토큰

    /* Environment */
    LOCAL: 'LOCAL', // 로컬
    DEV: 'DEV', // 개발
    STAGE: 'STAGE', // 검증
    PROD: 'PROD', // 운영
    SCMP: 'SCMP', // 삼성
    HCMP: 'HCMP', // 한화
    KECMP: 'KECMP', // Kakao Enterprise

    /* Data type */
    UNDEFINED: 'undefined',

    /* Site code */
    BESPIN: 'BESPIN', // *.Opsnow.com

    /* Value */
    CMPN_ID:' cmpnId', // Company ID

    // I18N
    I18N: {
        CHINA: "cn",
        KOREA: "ko",
        ENGLISH: "en",
        JAPANESE: "ja"
    },
    PARAM: {
        SELECT : {
            ALL :     'A',        // 모두보기
            UPDATE :  'U',        // Update
            NAME :    'N',        // Name
            SYSTEM:   'S',        // System
            CUSTOM :  'C',        // Custom
            RUNNING : 'R',        // Running
            FINISH :  'FINISH',   // Finish
            NULL:     null,       // Null
            NA:       "",         // N/A
            Y:        "Y",        // Yes (User Define)
            N:        "N",        // No  (User Define)
            NONE:     "none",      // None
            COMPLIANCE: "CMPL",
            NON_COMPLIANCE: "NON_CMPL",
            FILTER_ALL: ['FU','FS','P','R','E','N'],
            FILTER_NON_COMPLIANCE: ['FU', 'FS','F'],
            FILTER_COMPLIANCE: ['P'],
            ALERT_NOW: "actn_alertnow",
            SEARCH_SEVERITY: [1, 2, 3, 4]
        }
    },
    // Opsnow Code 정보
    LOGO_TYPE_IMG : "MSP_CMPN_LOGO_TYPE_010", // 로고 타입이 그림일 때 정의 코드
    LOGO_TYPE_TXT : "MSP_CMPN_LOGO_TYPE_020", // 로고 타입이 텍스트일 때 정의 코드
    //... more of your variables
    TYPE: {
        UNDEFINED: 'undefined'
    },
    SYSTEM_NAME: 'system',

    HIST_TYPE: {
        POLICY_CREATE: "policyCreate",
        POLICY_MODIFY: "policyModify",
        POLICY_COPY: "policyCopy",
        POLICY_DELETE: "policyDelete",
        RULE_CREATE: "ruleCreate",
        RULE_MODIFY: "ruleModify",
        RULE_COPY: "ruleCopy",
        RULE_DELETE: "ruleDelete",
        WHITELIST_CREATE: "whiteListCreate",
        WHITELIST_MODIFY: "whiteListUpdate",
        ACCOUNT_ADD: "accountAdd",
        ACCOUNT_DELETE: "accountDelete",
        ACCOUNT_UPDATE: "accountUpdate",
        INSPECTION_ADD: "inspectionAdd",
        INSPECTION_DELETE: "inspectionDelete",
        INSPECTION_UPDATE: "inspectionUpdate",
        COMPLIANCE_START: "complianceStart",
        COMPLIANCE_EXECUTE: "complianceExecute",
        COMPLIANCE_FINISH: "complianceFinish",
        ACTION_EXECUTE:"actionExecute",
        REGION_UPDATE:"regionUpdate"
    },
    HIST_FILTER: [
        {key: "policy", value: "POLICY" },
        {key: "rule", value: "RULE" },
        {key: "whiteList", value: "WHITELIST" },
        {key: "inspection", value: "SET_EVAL_ITEM" },
        {key: "compliance", value: "EVAL_POLICY" },
        {key: "region", value: "REGION_SETTING"},

    ],
    COMPLIANCE_STAT: {
        FAIL: "F",
        PASS: "P",
        EXAMINING: "R",
        ERROR: "E",
        UNEXAMINED: "N",
        FAIL_UNSOLVED: "FU",
        FAIL_SOLVED: "FS"
    },
    COMPLIANCE_STAT_FILTER:[
        {key : 'FU', val: 'POLICY.EVAL_STAT.FAIL_UNSOLVED'},
        {key : 'FS', val: 'POLICY.EVAL_STAT.FAIL_SOLVED'},
        {key : 'P', val: 'POLICY.EVAL_STAT.PASS'},
        {key : 'R', val: 'POLICY.EVAL_STAT.EXAMINING'},
        {key : 'E', val: 'POLICY.EVAL_STAT.ERROR'},
        {key : 'N', val: 'POLICY.EVAL_STAT.UNEXAMINED'}
    ],
    NON_COMPLIANCE_STAT_FILTER:[
        {key : 'FU', val: 'POLICY.EVAL_STAT.FAIL_UNSOLVED'},
        {key : 'FS', val: 'POLICY.EVAL_STAT.FAIL_SOLVED'},
        {key : 'R', val: 'POLICY.EVAL_STAT.EXAMINING'},
        {key : 'E', val: 'POLICY.EVAL_STAT.ERROR'},
        {key : 'N', val: 'POLICY.EVAL_STAT.UNEXAMINED'}
    ],
    SCHE_STAT_FILTER:[
        {key : 'A', val: 'LABEL.SCHEDULE_APPLY'},
        {key : 'M', val: 'LABEL.SCHEDULE_NOT_APPLY'}
    ],
    POLICY_TYPE_FILTER:[
        {key : '', val: 'FILTER.SELECT_POLICY_TYPE'},
        {key : 'A', val: 'LABEL.VIEW_ALL'},
        {key : 'N', val: 'LABEL.VIEW_SYSTEM_POLICY_ONLY'},
        {key : 'Y', val: 'LABEL.VIEW_USER_SETTINGS_ONLY'}
    ],
    SCHE_TYPE_FILTER:[
        {key : 'A', val: 'LABEL.VIEW_ALL'},
        {key : 'N', val: 'LABEL.SCHEDULE_APPLY'},
        {key : 'Y', val: 'LABEL.SCHEDULE_NOT_APPLY'}
    ],
    SVRTY_FILTER:[
        {key : 4, val: 'LABEL.SVRTY.4'},
        {key : 3, val: 'LABEL.SVRTY.3'},
        {key : 2, val: 'LABEL.SVRTY.2'},
        {key : 1, val: 'LABEL.SVRTY.1'}
    ],
    TEMPLATE_PROPERTIES:{
        NUMBER:         'num',      // 숫자 입력(INPUT)
        CURRENCY:       'cur',      // 통화 입력(INPUT)
        TIME:           'time',     // 시간 입력(INPUT)
        PERCENT:        'pct',      // 퍼센트 입력 (INPUT)
        TYPE_VAL:       'typeVal',  // UNIT TYPE 등(SELECT)
        VIEW:           'view',     // VIEW (SELECT)
        SERVICE_GROUP:  'svcGrp',   // 서비스 그룹 (MULTI-SELECT)
        PORT:           'port',     // 포트 번호 입력(INPUT)
        RESOURCE:       'rsrc',     // 리소스 관련 (SELECT, MULTI-SELECT)
        PERIOD:         'peri',     // 주기(일,주,월,년) (SELECT)
        AWS_CONFIG:     'cfg',      // AWS CONFIG RULE(SELECT)
        TAG:            'tag'       // Tag Key (SELECT)
    },
    GUIDE_VIEW_TYPE:{
        LIST: 'list',
        VIEW: 'view',
        SEARCH: 'search'
    },
    POLICY_TYPE:{
        BEST_PRACTICE: 'bestPractice'
    },
    NUM: {
        ROW_PER_PAGE: 10,
        RESOURCE_ROW_PER_PAGE: 10
    },
    FORM_TYPE: {
        NEW: 0,
        EDIT: 1,
        COPY: 2
    },
    PRESET_ROWS_PER_PAGE: [10, 20, 30, 40, 50],
    CONJUNCTION_OPTIONS: [
        {key: 'and', val: 'COMMON.CONJUNCTION.and'},
        {key: 'or', val: 'COMMON.CONJUNCTION.or'}
    ],// AND || OR 조건 필터 옵션
    SEVERITY_OPTIONS: [ // 심각도 필터 옵션
        {key: '1', val: 'LABEL.SVRTY.1', dataIcon: 'low'},
        {key: '2', val: 'LABEL.SVRTY.2', dataIcon: 'medium'},
        {key: '3', val: 'LABEL.SVRTY.3', dataIcon: 'high'},
        {key: '4', val: 'LABEL.SVRTY.4', dataIcon: 'critical'}
    ],
    CHART_TYPE_OPTIONS: [
        {"key": "prodList", "val": "FILTER.BY_PRODUCT"},
        {"key": "ctgList", "val": "FILTER.BY_CATEGORY"}
    ],
});




// WEBPACK FOOTER //
// ./src/components/common/global.constants.js